import { Empty, Select, Space, Typography, notification as toast } from "antd"
import Layout from "modules/layout/dashboard"

import styles from "./styles.module.scss"
import Loader from "components/loader"
import { useTranslation } from "react-i18next"
import { useMember } from "../../queries"
import { useToSubscribeActivities } from "./queries"
import { useMemberId } from "pages/member"
import { useSearchParams } from "react-router-dom"
import Search from "antd/es/input/Search"
import useOptions from "utils/use-options"
import { useExtSessions } from "../list/queries"
import ActivityItem from "./activityItem"

const { Title } = Typography
const { Main } = Layout
export const SESSION_PARAM = "session"

const Registration: React.FC = () => {
  const memberId = useMemberId()
  const member = useMember(memberId)
  const { t } = useTranslation()
  const sessions = useExtSessions(
    {
      filter: {
        status: { values: ["published", "progress"], operator: "in" },
      },
    },
    {
      select(data) {
        return data.some((session) => session.status === "published")
          ? data.filter((session) => session.status === "published")
          : data
      },
      onSuccess(data) {
        if (data.length === 0) {
          searchParams.delete(SESSION_PARAM)
          setSearchParams(searchParams, { replace: true })
          toast.error({
            message: t("errors.error"),
            description: t("events.not_found_session"),
            placement: "top",
          })
        } else if (!searchParams.has(SESSION_PARAM)) {
          const hasPublishedSession = data.some(
            (session) => session.status === "published"
          )
          const filteredSession = hasPublishedSession
            ? data.find((session) => session.status === "published")
            : data.find((session) => session.status === "progress")
          filteredSession && handleSessionFilter(filteredSession.id)
        }
      },
    }
  )

  const [searchParams, setSearchParams] = useSearchParams()

  const { data, isLoading } = useToSubscribeActivities(
    memberId!,
    searchParams.get(SESSION_PARAM)
      ? {
          session_id: searchParams.get(SESSION_PARAM),
        }
      : undefined,
    {
      enabled: !!sessions.data && sessions.data.length > 0,
    }
  )

  const options = useOptions(data)

  const handleSessionFilter = (value: string) => {
    searchParams.set(SESSION_PARAM, value)
    setSearchParams(searchParams, { replace: true })
  }

  return (
    <>
      <Main.PageHeader
        breadcrumbs={[
          {
            title: member.data?.name,
            link: `/members/${member.data?.id}/events`,
          },
          {
            title: t("events.presubscriptions"),
          },
        ]}
        title={<Title level={3}> {t("events.presubscriptions")} </Title>}
        rightContent={
          <Space>
            <Select
              value={
                !sessions.isLoading ? searchParams.get(SESSION_PARAM) : null
              }
              style={{ width: "100%" }}
              placeholder={t("global.select", {
                entity: t("events.session"),
                context: "female",
              })}
              loading={sessions.isLoading}
              onChange={handleSessionFilter}
              options={sessions.data?.map((session) => ({
                value: session.id,
                label: session.name,
              }))}
            />
            <Search
              value={options.search}
              onChange={(e) => {
                options.setSearch(e.target.value)
              }}
              placeholder={t("global.search")}
              style={{ width: "100%" }}
            />
          </Space>
        }
      />
      {(isLoading && sessions.data && sessions.data.length > 0) ||
      sessions.isLoading ? (
        <Loader />
      ) : (
        <>
          {(sessions.data && sessions.data.length === 0) ||
          (options.options && options.options.length === 0) ? (
            <div className={styles.emptyDataContainer}>
              <Empty />
            </div>
          ) : (
            <div className={styles.cardsContainer}>
              {options?.options?.map((activity) => (
                <ActivityItem key={activity.id} activity={activity} />
              ))}
            </div>
          )}
        </>
      )}
    </>
  )
}

export default Registration
